import { AfterViewInit, Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({ selector: '[appAutoOpenSelect]' })
export class AutoOpenSelectDirective implements AfterViewInit {
  private matSelect = inject(MatSelect);
  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input() row: any;
  @Input() col!: string;
  @Input() previousValue: any;
  @Input() stopEdit!: () => void;
  @Input() cancelEdit!: (row: any, col: string) => void;

  ngAfterViewInit() {
    setTimeout(() => {
      this.matSelect.open(); // ouvre automatiquement le select
    });
  }

  @HostListener('keydown.escape', ['$event'])
  handleEscape(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.cancelEdit) {
      this.cancelEdit(this.row, this.col);
    }
  }

  @HostListener('closed')
  handleClosed() {
    if (this.stopEdit) {
      this.stopEdit();
    }
  }
}
